import React from 'react';
import { createRoot } from 'react-dom/client';
// third party
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import {thunk} from 'redux-thunk';
import { createStore, applyMiddleware, compose  } from 'redux';
import reducer from './store/reducer';

import 'bootstrap/dist/css/bootstrap.css';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
// const store = createStore(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), applyMiddleware(thunk));


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducer, composeEnhancers(
    applyMiddleware(thunk)
));

root.render(
  <Provider store={store}>
    <HashRouter basename="/">
    
        <App />
     
    </HashRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

